import { content } from 'core';
import { useMatch, useNavigate } from 'react-router';
import { Layout } from 'ui/components/primitives';
import { ContentBuilder, widgetsMapper as pageComponentsMapper } from 'ui/containers';

import type { PageProps } from './@types';

export const PageBuilder = ({ documentType, route, children }: PageProps) => {
  const navigate = useNavigate();
  const { data, isError, isLoading, isSuccess } = content.hooks.useContent(documentType);
  const match = useMatch(route);
  if (isError) {
    navigate('/error-generic');
  }

  return (
    <Layout fullPage horizontalAlign="left" loading={isLoading} verticalAlign="top">
      {isSuccess && (
        <>
          {children}
          <ContentBuilder
            components={data.components}
            match={match}
            widgetsMapper={pageComponentsMapper}
          />
        </>
      )}
    </Layout>
  );
};

export default PageBuilder;
